import { render, staticRenderFns } from "./ModalInput.vue?vue&type=template&id=d06624d2&scoped=true&"
import script from "./ModalInput.vue?vue&type=script&lang=ts&"
export * from "./ModalInput.vue?vue&type=script&lang=ts&"
import style0 from "./ModalInput.vue?vue&type=style&index=0&id=d06624d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06624d2",
  null
  
)

export default component.exports